export const MSGS = {
  PAYROLL_ADD_SUCCESS: "Payroll added successfully",
  PAYROLL_EDIT_SUCCESS: "Payroll edited successfully",
  PAYROLL_DELETE_SUCCESS: "Payroll deleted successfully",
  PAYROLL_CONTACT_US_SUCCESS: "Thank you for submitting your query. Worksana Support team member would get in touch with you shortly.",
  CALIFORNIA_DEFAULT_MESSAGE: "This is the 7th consecutive work day for you, in the work week. Your first 8 hours today would be considered as overtime. Any additional hours there on would be double overtime. Please confirm to Punch In?."
};

export default MSGS;
